/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

(function () {
  function makeNumber(inputString) {
    return parseInt(inputString, 10);
  }

  let featuresSliderInit = false;

  function productFeaturesSlider() {
    if ($(window).width() < 576) {
      if (!featuresSliderInit) {
        $('.product-features-slider').slick({
          arrows: false,
          dots: false,
          slidesToShow: 3,
          centerMode: true,
          centerPadding: '12%',
          slidesToScroll: 2,
          mobileFirst: true,
          responsive: [{ breakpoint: 576, settings: 'unslick' }],
        });

        featuresSliderInit = true;
      }
    } else if ($(window).width() > 576) {
      if (featuresSliderInit) {
        $('.product-features-slider').slick('unslick');
        featuresSliderInit = false;
      }
    }
  }

  productFeaturesSlider();

  $(window).on('resize', function () {
    productFeaturesSlider();
  });

  $(document).on('click', '.cart-input-number-btn', function () {
    var $button = $(this);
    var oldValue = $button.parent().find('input').val();

    if ($button.text() == '+') {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }
    $button.parent().find('input').val(newVal).trigger('input');
  });

  function changeInputNumber(action, target) {
    const step = 1;
    const min = target.attr('min') || 1;
    const max = target.attr('max') || 10000000000;
    const num = makeNumber(target.val());
    let newVal;

    if (action === 'plus') {
      newVal = num + step <= max ? num + step : num;
    } else if (action === 'minus') {
      newVal = num - step >= min ? num - step : num;
    }

    if (newVal !== num) {
      target.val(newVal);

      target.trigger('change');
    }
  }

  $('.site-header__section > button').on('click', function () {
    const status = $('.navigation').attr('aria-hidden');
    const opacity = $('.navigation').css('opacity');
  });

  // size chart modal button
  $('.size-chart-button').on('click', function () {
    $('.size-chart-modal').show();
  });

  $('.close-modal').on('click', function () {
    $('.size-chart-modal').hide();
  });

  $(window).on('click', function (e) {
    if ($(e.target).hasClass('size-chart-modal')) {
      $('.size-chart-modal').hide();
    }
  });



  // product images slider and slider nav
  document.addEventListener('DOMContentLoaded', function (){
    $('.product-slider').slick('refresh');
    console.log('refresh')
  })

  $('.product-slider').slick({
    arrows: true,
    dots: false,
    infinite: false,
    slidesToShow: 1,
    adaptiveHeight: true,
    asNavFor: '.product-slider-nav',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          customPaging: function (slick, index) {
            return '<div class="custom-pagination-item"></div>';
          },
        },
      },
    ],
  });

  $('.product-slider').on('beforeChange', function (_, _, _, nextSlide) {
    const selector = `.product-slider .product-slider-item[data-slick-index="${nextSlide}"]`;
    const hasIframe = $(selector).find('iframe').length > 0;
    const hasCircle = $(selector).find('.image-circle').length > 0;

    if (hasIframe) {
      $('.product-slider-container .bg-circle').css('opacity', '0');
      $('.product-slider').css('min-height', '1px');
    } else if (hasCircle) {
      $('.product-slider-container .bg-circle').css('opacity', '0');
    } else {
      $('.product-slider-container .bg-circle').css('opacity', '1');
      $('.product-slider').removeAttr('style');
    }
  });

  $('.product-slider-nav').slick({
    arrows: false,
    dots: false,
    infinite: false,
    slidesToShow: 4,
    asNavFor: '.product-slider',
    focusOnSelect: true,
  });

  // testimonials section slider

  $('.testimonials-slider').slick({
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    customPaging: function (slick, index) {
      return '<div class="custom-pagination-item"></div>';
    },
  });

  // youtube overlay click

  $('.image-overlay').on('click', function () {
    $(this).hide();
    $('.video-wrapper iframe').css('opacity', '1');
    let src = $('.video-wrapper iframe').attr('src');
    src = src + '&autoplay=1';
    $('.video-wrapper iframe').attr('src', src);

  });

  // Cart Input number + and - buttons

  $('.cart-input-number-btn1').on('click', function () {
    const target = $(this).siblings('input');
    const action = $(this).data('action');
    changeInputNumber(action, target);
  });

  $('.qty-input-number-btn').on('click', function () {
    const target = $(this).siblings('input');
    const action = $(this).data('action');
    changeInputNumber(action, target);
  });

  // qty number

  // Before and after slider
  $('.before-and-after-wrapper').twentytwenty({
    no_overlay: true, //Do not show the overlay with before and after
    move_slider_on_hover: true, // Move slider on mouse hover?
    move_with_handle_only: false, // Allow a user to swipe anywhere on the image to control slider movement.
    click_to_move: false, // Allow a user to click (or tap) anywhere on the image to move the slider to that location.
  });

  $('.twentytwenty-before-label').on('click', function() {
    $('.twentytwenty-handle').css("left", "100%");
    $('.twentytwenty-before').css("clip", "rect(0px, 100vw, 100vh, 0px)");
  })

  $('.twentytwenty-after-label').on('click', function() {
    $('.twentytwenty-handle').css("left", "0");
    $('.twentytwenty-before').css("clip", "rect(0px, 0, 100vh, 0px)");
  })

  // Product tabs

  $('.tab-button').on('click', function () {
    const target = $(this).data('target');
    $('.tab-content-wrapper').removeClass('active');
    $('.tab-button').removeClass('active');
    $(target).addClass('active');
    $(this).addClass('active');

    $(".tab-button-mobile").prop("checked", false);
    $(`#${$(this).attr('id')}-mobile`).trigger("click");
  });

  $('.submit').on('click', function () {
    $('.ajax-cart__toggle').trigger('click');
  });

  if ($('#opinew-stars-plugin-product').length > 0) {
    $('.opinew-stars-plugin-link').removeAttr('onclick');
    const currentReviews = $('.opinew-no-reviews-stars-plugin b')
      .text()
      .match(/\d+/g)[0];

    $('.opinew-no-reviews-stars-plugin').text(`${currentReviews} Reviews`);
  }

  $('.opinew-stars-plugin-link').on('click', function (e) {
    if ($('button#reviews').length) {
      e.preventDefault();
    }

    $('button#reviews').trigger('click');

    setTimeout(() => {
      $('html, body').animate(
        {
          scrollTop: $('button#reviews').offset().top,
        },
        800
      );
    }, 200);
  });

  const smoothScroll = (hash) => {
    let target = $(hash);
    if (target.length > 0) {
      if (target.hasClass('tab-button')) {
        target.trigger('click');

        if (window.screen.width <= 768) {
          target = $(`${hash}-mobile`);
        }
      }

      $('html, body').animate(
        {
          scrollTop: target.offset().top,
        },
        800,
        function () {
          window.location.hash = hash;
        }
      );
    }
  }

  $('a').on('click', function (e) {
    const hash = this.hash;
    if (hash !== '' && window.location.pathname == this.pathname) {
      e.preventDefault();

      smoothScroll(hash);
    }
  });

  $(document).ready(function () {
    const hash = window.location.hash;
    if (hash && hash !== '') {
      smoothScroll(hash);

      if ($('.opw-review-form-container').length === 0) {
        setTimeout(function(){
          $('.opw-navbar-button-write-review').trigger('click');
        },1000);
      }
    }
  });

/*('a[href="/pages/subscribe"]').on('click', function (e) {
    e.preventDefault();
    $('.site-header__navigation.btn.btn--clear.btn--square').trigger('click');
    setTimeout(function () {
      $('html, body').animate(
        {
          scrollTop: $('#subscribe').offset().top,
        },
        800
      );
    }, 200);

    setTimeout(function () {
      window.location.hash = '#subscribe';
    }, 300);
  });*/

  $('.navigation__links a').on('click', function () {
    setTimeout(() => {
      $('.site-header__navigation.btn.btn--clear.btn--square').trigger('click');
    }, 300);
  });

  const printSelect = '.selects-wrapper .product-form__item:first-child select';
  const sizeSelect = '.selects-wrapper .product-form__item:nth-child(2) select';

  function formatOption(data) {
    let img = '';

    if (data.element) {
      img = data.element.dataset.img;
    }

    return $(
      `<span><img src="${img}" alt="swatch" class="item-swatch" /> ${data.text}</span>`
    );
  }

  $(printSelect).select2({
    templateResult: formatOption,
    templateSelection: formatOption,
    minimumResultsForSearch: -1,
  });

  $(sizeSelect).select2({
    minimumResultsForSearch: -1,
  });

  if (window.screen.width <= 768) {
    $('#chck1').prop('checked', true);
  }

  function clickHandler(div) {
    $('html, body').animate(
      {
        scrollTop: $(div).offset().top,
      },
      1000
    );
  }
})(jQuery);